import { withTranslation } from '@common/helpers';
import { FilterProps } from '@common/types/types';

export const defaultFilters = {
  searchString: '',
  searchType: 'description',
  settings: '',
  issueType:'',
  status: '',
  period: '',
  dateFrom: '',
  dateTo: ''
};

export const statusMap: FilterProps[] = [
  {
    value: 'all',
    label: 'allStatuses',
  },
  {
    value: 'opened',
    label: 'openedStatus.label',
    color: '#1349D5',
    description: 'openedStatus.description',
  },
  {
    value: 'resolved',
    label: 'resolvedStatus.label',
    color: '#5500C2',
    description: 'resolvedStatus.description',
  },
  {
    value: 'closed',
    label: 'closedStatus.label',
    color: '#035E11',
    description: 'closedStatus.description',
  },
  {
    value: 'reopened',
    label: 'reopenedStatus.label',
    color: '#1349D5',
    description: 'reopenedStatus.description',
  },
  {
    value: 'archived',
    label: 'archivedStatus.label',
    color: '#1349D5',
    description: 'archivedStatus.description',
  },
];

export const paymentPlanMap: FilterProps[] = [
  {
    value: 'all',
    label: withTranslation('users', 'allPlans'),
  },
  {
    value: 'free',
    label: withTranslation('users', 'freePlan'),
  },
  {
    value: 'basic',
    label: withTranslation('users', 'basicPlan'),
  },
  {
    value: 'professional',
    label: withTranslation('users', 'professionalPlan'),
  },
  {
    value: 'advanced',
    label: withTranslation('users', 'advancedPlan'),
  },
];

export const isActiveUserMap: FilterProps[] = [
  {
    value: 'all',
    label: withTranslation('users', 'allUsersStatus'),
  },
  {
    value: 'Active',
    label: withTranslation('users', 'true'),
  },
  {
    value: 'Not Active',
    label: withTranslation('users', 'false'),
  },
];

export const userTypeMap: FilterProps[] = [
  {
    value: 'all',
    label: withTranslation('users', 'allUsers'),
  },
  {
    value: 'websiteOwner',
    label: withTranslation('users', 'websiteOwner'),
  },
  {
    value: 'widgetUser',
    label: withTranslation('users', 'widgetUser'),
  },
];

export const tenantMap: FilterProps[] = [
  {
    value: 'all',
    label: withTranslation('users', 'allTenants'),
  },
];

export const searchTypeMap: FilterProps[] = [
  {
    value: 'description',
    label: 'searchTypesMap.description',
  },
  {
    value: 'reportNumber',
    label: 'searchTypesMap.reportNumber',
  },
  {
    value: 'browser',
    label: 'searchTypesMap.browser',
  },
  {
    value: 'os',
    label: 'searchTypesMap.os',
  },
  {
    value: 'type',
    label: 'searchTypesMap.type',
  },
  {
    value: 'url',
    label: 'searchTypesMap.url',
  },
  {
    value: 'settings',
    label: 'searchTypesMap.settings',
  }
];

export const widgetSettingsMap: FilterProps[] = [
  {
    value: '',
    label: 'widgetSettingsMap.default',
  },
  {
    value: 'biggerTextControl',
    label: 'widgetSettingsMap.biggerTextControl',
  },
  {
    value: 'biggerTextSpacingControl',
    label: 'widgetSettingsMap.biggerTextSpacingControl',
  },
  {
    value: 'biggerLineHeightControl',
    label: 'widgetSettingsMap.biggerLineHeightControl',
  },
  {
    value: 'muteControl',
    label: 'widgetSettingsMap.muteControl',
  },
  {
    value: 'pauseAnimationControl',
    label: 'widgetSettingsMap.pauseAnimationControl',
  },
  {
    value: 'pauseVideoControl',
    label: 'widgetSettingsMap.pauseVideoControl',
  },
  {
    value: 'unColorDisplayControl',
    label: 'widgetSettingsMap.unColorDisplayControl',
  },
  {
    value: 'reverseContrastControl',
    label: 'widgetSettingsMap.reverseContrastControl',
  },
  {
    value: 'brightContrastControl',
    label: 'widgetSettingsMap.brightContrastControl',
  },
  {
    value: 'zoomControl',
    label: 'widgetSettingsMap.zoomControl',
  },
  {
    value: 'blackCursorControl',
    label: 'widgetSettingsMap.blackCursorControl',
  },
  {
    value: 'whiteCursorControl',
    label: 'widgetSettingsMap.whiteCursorControl',
  },
  {
    value: 'hideMediaControl',
    label: 'widgetSettingsMap.hideMediaControl',
  },
  {
    value: 'showAltTextControl',
    label: 'widgetSettingsMap.showAltTextControl',
  },
  {
    value: 'mouseKeyCursorControl',
    label: 'widgetSettingsMap.mouseKeyCursorControl',
  },
  {
    value: 'readingMaskControl',
    label: 'widgetSettingsMap.readingMaskControl',
  },
  {
    value: 'readingBarControl',
    label: 'widgetSettingsMap.readingBarControl',
  },
  {
    value: 'highlightOnFocusControl',
    label: 'widgetSettingsMap.highlightOnFocusControl',
  },
  {
    value: 'highlightOnHoverControl',
    label: 'widgetSettingsMap.highlightOnHoverControl',
  }
];

export const issueTypeMap: FilterProps[] = [
  {
    value: '',
    label: 'issueTypesMap.default',
  },
  {
    value: 'context',
    label: 'issueTypesMap.context',
  },
  {
    value: 'navigationIssues',
    label: 'issueTypesMap.navigationIssues',
  },
  {
    value: 'noLabel',
    label: 'issueTypesMap.noLabel',
  },
  {
    value: 'other',
    label: 'issueTypesMap.other',
  }
];
